import { Paragraph } from "../../../../atoms";
import { Flex } from "../../../../cores";
import { IconPumpScore } from "../../../../icons";

interface IGuaranteePointsDescription {
  valueApproved: string;
}
const GuaranteePointsDescription = ({
  valueApproved,
}: IGuaranteePointsDescription) => {
  return (
    <Flex>
      <IconPumpScore value={valueApproved} />
      <Paragraph>Godkänt</Paragraph>
    </Flex>
  );
};

export default GuaranteePointsDescription;
